export default __webpack_public_path__ + "static/media/diaganostic105.baea9726.jpg";